import React from "react"
import styled from "styled-components"
import DesignTokens from "./designTokens"
import { ScreenClassRender } from "react-grid-system"
import { Heading } from "./typography"
import RichContentTextBlock from "./richContentTextBlock"
import Img from "gatsby-image"
import { LinkButtonTertiary } from "./button"
import { Box, Container, Grid, Flex } from "@theme-ui/components"
import { Link } from "gatsby"
import { getApplicationPath } from "./pathUtils"
import { LanguageContext } from "../locales/langContext"

const ImageandText = ({ section }) => (
  <LanguageContext.Consumer>
    {t => (
      < Wrapper paddingBottom={section.paddingBottom}>
        <Container variant="small">
          <Grid
            columns={[1, 1, 2]}
            gap={["24px"]}
            sx={{ alignItems: "stretch" }}
          >
            {/* Left: Main Image */}
            <Box
              sx={{
                ".gatsby-image-wrapper": { height: "100%" },
                minHeight: ["240px", "320px", "100%"],
              }}
            >
              {section.image && <Img fluid={section.image.fluid} />}
            </Box>
            {/* Right: Cards */}
            <Flex
              sx={{
                flexDirection: "column",
                height: "100%",
                gap: "24px",
              }}
            >
              {section.cards &&
                section.cards.map((card, idx) => (
                  <CardBox
                    key={idx}
                    idx={idx}
                    sx={{
                      backgroundColor: idx === 0 ? "#f4f3ee" : "primary",
                      color: idx === 0 ? "primary" : "white",
                      p: ["32px", "32px"],
                      gap: "16px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      position: "relative",
                      flex: "1",
                      justifyContent: "space-between",
                    }}
                  >
                    {card.image && card.image.url && (
                      <img
                        src={card.image.url}
                        alt="icon"
                        style={{
                          width: 48,
                          height: 48,
                          marginBottom: section.imagePosition === "bottom-right" ? 0 : 16,
                          position: section.imagePosition === "bottom-right" ? "absolute" : "static",
                          bottom: section.imagePosition === "bottom-right" ? "32px" : "auto",
                          right: section.imagePosition === "bottom-right" ? "32px" : "auto",
                        }}
                      />
                    )}
                    <Box>
                      {card.title && (
                        <Heading
                          color={idx === 0 ? "primary" : "white"}
                          style={{
                            marginBottom: "16px",
                            fontSize: "39px",
                            fontWeight: "700",
                          }}
                        >
                          {card.title}
                        </Heading>
                      )}
                      {card.body && (
                        <RichContentTextBlock
                          html={card.body}
                          color={idx === 0 ? "primary" : "white"}
                        />
                      )}
                    </Box>
                    {card.document && card.document.url && (
                      <DownloadLink
                        href={card.document.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        idx={idx}
                      >
                        {t.download}
                      </DownloadLink>
                    )}
                  </CardBox>
                ))}
            </Flex>
          </Grid>
        </Container>
      </Wrapper>
    )}
  </LanguageContext.Consumer >
)
const Wrapper = styled.div`
  padding-bottom: ${props => {
    switch (props.paddingBottom) {
      case "none":
        return "0";
      case "large":
        return "3rem";
      case "normal":
      default:
        return "1.5rem";
    }
  }};

  @media screen and (min-width: 768px) {
    padding-bottom: ${props => {
      switch (props.paddingBottom) {
        case "none":
          return "0";
        case "large":
          return "6rem";
        case "normal":
        default:
          return "3rem";
      }
    }};
  }
`

const CustomBackground = styled.div`
  position: absolute;
  color: white;
  bottom: 0rem;
  ${props => (props.alignment ? `right: 3rem;` : `left: 3rem;`)}
  padding: 2rem 2rem;
  background: ${DesignTokens.colors.primary[500]};
  width: 600px;
  @media screen and (max-width: 768px) {
    position: relative;
    width: 100%;
    left: 0;
    bottom: 0;
  }

  & > * {
    margin-bottom: 2rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`

const StyledLink = styled(Link)`
  color: white;
  text-transform: uppercase;
  text-decoration: none;
  padding-left: 3rem;
  background-image: linear-gradient(90deg, #ffffff, #ffffff);
  background-size: 36px 1px;
  background-position: 0 50%;
  background-repeat: no-repeat;
`

const StyledBox = styled.div`
  margin-top: 2rem;
  padding: 3rem;
  & > * {
    margin-bottom: 2rem;
    &:last-child {
      margin-bottom: 0;
    }
  }
`

const CardBox = styled(Box)``

const DownloadLink = styled.a`
  color: ${props => props.idx === 0 ? "#00793D" : "white"};
  text-decoration: underline;
  font-weight: 500;
  margin-top: 16px;
  display: inline-block;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
`

export default ImageandText
